import React, { Component } from "react";
import { Form, Input,Row } from 'antd';
import NHFormItem from '../common/NHFormItem';
import css from './index.css'; 
import NHSelect from "../common/NHSelect";
import NHFetch from '../../utils/NHFetch';
const { TextArea } = Input;
const basicUrl = "/newStudent/"; //基础路径
/**
 * 班级管理编辑表单 
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [], //班级下拉数据 
            bjvalue:"",
        }
    }

    componentDidMount() { 
        this.getXyxxData();
    }

      //加载学院数据
      getXyxxData = () => {
        NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', { tag: 'xy', filter: '' })
            .then(res => {
                if (res) {
                    this.setState({ xyxxData: res.data ? res.data : [] });
                }
            });
    }

    //部门信息选择回调
    handleXyxxChange = (value) => {
        const {getFieldValue, setFieldsValue} = this.props.form;
        if (value && value.length > 0) {
            NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'zy', filter: value.toString()})
                .then(res => {
                    if (res) {
                        let zyids = getFieldValue('zyid');
                        if (zyids && res.data && zyids.length > 0 ){
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newZyids = zyids.filter(item => newData.has(item));
                            setFieldsValue({zyid:newZyids});
                            this.handleZyxxChange(newZyids);
                        }
                        this.setState({zyxxData: res.data ? res.data : []});
                        setFieldsValue({zy:[], bj:[]});
                    }
                })

        } else {
            const {setFieldsValue} = this.props.form;
            setFieldsValue({zy:[], bj:[]});
            this.setState({zyxxData:[], bjxxData:[]});
        }

    }

      //专业信息选择回调
      handleZyxxChange = (value) => {
          const {getFieldValue, setFieldsValue} = this.props.form;
          if (value && value.length > 0) {

              NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'bj', filter: value.toString()})
                  .then(res => {
                      if (res) {
                          let bjids = getFieldValue('bjid');
                          if (bjids && res.data && bjids.length > 0 ){
                              let newData = res.data.map(item => item.VALUE);
                              newData = new Set(newData);
                              let newBjids = bjids.filter(item => newData.has(item));
                              setFieldsValue({bjid:newBjids});
                          }
                          this.setState({bjxxData: res.data ? res.data : []});
                          setFieldsValue({bj:[]});
                      }
                  })

          } else {
              setFieldsValue({bjid:[]});
              this.setState({bjxxData:[]});
          }
      }
    //
    handleBJxxChange=(value)=>{

      if(this.props.getValue!==undefined){ 
        this.props.getValue(value);
      }else{                             //新增的受控
         this.setState({
          bjvalue:value
         })
      }
         
    }

    render() {
        const {form,initFormData,flag} = this.props;
        const { xyxxData, zyxxData, bjxxData } = this.state;
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        
        return (
            <div>
                <Form layout="horizontal">
                    {/* <div style={{ display: 'none' }} >
                        <NHFormItem label="主键" id={"pkid"}
                            form={form} initialValue={initFormData.PKID} >
                            <Input />
                        </NHFormItem>
                    </div>  */}
                     <NHFormItem id={"tip"}  form={this.props.form} formItemLayout={formItemLayout}>
                        <Row style={{ fontSize:'20px',lineHeight:'1.5',color: 'rgba(0, 0, 0, 0.85)'}}>
                            <span >所选学生班级调整为</span>
                        </Row>
                    </NHFormItem>
                    <NHFormItem id={"xy"} required={true} label={"学院"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.YXH}> 
                      <NHSelect mode="default" dataSource={xyxxData} onChange={this.handleXyxxChange} style={{width:400}}/>  
                </NHFormItem>
                <NHFormItem id={"zy"} required={true} label={"专业"}
                            initialValue={initFormData.ZYH}
                            form={this.props.form} formItemLayout={formItemLayout}> 
                              <NHSelect mode="default" dataSource={zyxxData}  onChange={this.handleZyxxChange} style={{width:400}}/> 
                   
                </NHFormItem>
                <NHFormItem id={"bj"} required={true} label={"班级"}
                            initialValue={initFormData.BJH} formItemLayout={formItemLayout}
                            form={this.props.form}>
                     <NHSelect  mode="default" dataSource={bjxxData} onChange={this.handleBJxxChange} style={{width:400}} value={this.state.bjvalue}/>
                </NHFormItem>
                <NHFormItem id={"sqly"} required={false} label={"调整理由"}
                            initialValue={initFormData.SQLY}
                            form={this.props.form} formItemLayout={formItemLayout}>
                           
                             <TextArea maxLength ={80} placeholder="请填写调整理由" style={{width:'400px'}} /> 
                </NHFormItem>

                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/classManagement/EditForm.js